type Translate = (message: string, options?: Record<string, unknown>) => string;

/**
 * What a cart release created, naming transfer orders apart from purchase
 * orders: a line switched to a transfer is released as its own transfer order
 * (GEN-3023). Null when nothing was created.
 */
export function releaseCreatedMessage(
  gt: Translate,
  counts: { purchaseOrders: number; transferOrders: number },
): string | null {
  const { purchaseOrders, transferOrders } = counts;
  if (purchaseOrders > 0 && transferOrders > 0) {
    return gt(
      'Created {poCount, plural, =1 {# purchase order} other {# purchase orders}} and {toCount, plural, =1 {# transfer order} other {# transfer orders}}',
      {
        context: 'release toast, purchase and transfer orders created',
        poCount: purchaseOrders,
        toCount: transferOrders,
      },
    );
  }
  if (transferOrders > 0) {
    return gt(
      '{count, plural, =1 {Created # transfer order} other {Created # transfer orders}}',
      {
        context: 'release toast, transfer orders created',
        count: transferOrders,
      },
    );
  }
  if (purchaseOrders > 0) {
    return gt(
      '{count, plural, =1 {Created # purchase order} other {Created # purchase orders}}',
      {
        context: 'release toast, purchase orders created',
        count: purchaseOrders,
      },
    );
  }
  return null;
}
